import { MutationCache, QueryClient } from "@tanstack/react-query";
import { message } from "antd";
import { getErrorMessage } from "./functions";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
    },
  },

  mutationCache: new MutationCache({
    onError: (error) => {
      const routeList = ["/user/login"];

      if (error.response?.data?.result?.message !== "Expired or Invalid Token") {
        if (error?.config?.url && !routeList.includes(error?.config?.url)) {
          // message.error(error.response?.data?.message?.replace("Error:", "").toSentenceCase());
          message.error(getErrorMessage(error));
        }
      }
    },
  }),
});
